export const overrides = {
  MuiPaper: {
    root: {
      borderRadius: 0.0001, // bug-fix for when dropshadows are too dark without a border-radius set, in some browsers
    },
  },
  MuiFormLabel: {
    root: {
      fontSize: 14, // Zeno uses 14px font-size for FormLabels - the Material UI default is 16px
    },
  },
};
